import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../core/services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { SignaturePad } from 'angular2-signaturepad';
import { ImageCacheService } from 'src/app/core/services/image/image-cache.service';
import { PenPowerSignSDK } from '../../../core/services/signature/penpower-sign-sdk';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  @ViewChild('password') confpassword!: ElementRef;
  @ViewChild('liveSignatureCanvas', { static: false }) liveSignatureCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild(SignaturePad) signaturePad!: SignaturePad;
  showSignaturePad = false;
  loadingSignature = false;
  signaturePadOptions: Object = { 
    'minwidth': 2,
    penColor: 'rgb(1, 1, 1)',
    backgroundColor: 'rgb(255, 255, 255)',
    canvasWidth: 300,
    canvasHeight: 150
  };
  userinfo: any;
  session: any;
  agence: any;
  passwordForm: any;
  chgPassword: boolean;
  status: boolean;
  validform: boolean;
  profileImageBase64: string | null = null;
  penPowerSdk: PenPowerSignSDK | null = null;
  signatureStatus: boolean = false;
  isDeviceConnected: boolean = false;
  signatureTimeoutId: any;
  signatureTimeLeft: number = 120;
  signatureTimerInterval: any;

  constructor(private dialogref: MatDialogRef<ProfileComponent>, private fb: FormBuilder, private userservice: UserService, private toastrService: ToastrService,
    private imageCacheService: ImageCacheService, private cdr: ChangeDetectorRef) {
    this.confpassword = {} as ElementRef;
    this.userinfo = localStorage.getItem('userinfo');
    this.userinfo = JSON.parse(this.userinfo);
    this.userinfo = this.userinfo[0];
    this.session = localStorage.getItem('session');
    this.agence = localStorage.getItem('agenceinso');
    this.agence = this.agence ? JSON.parse(this.agence) : null;
    this.chgPassword = false;
    this.status = false;
    this.validform = false;
  }

  close(): void {
    this.dialogref.close();
  }

  changePassword(): any {
    if (this.chgPassword) {
      this.chgPassword = false;
    } else {
      this.chgPassword = true;
    }
  }

  ngOnInit(): void {
    this.agence = localStorage.getItem('agenceinso');
    this.agence = this.agence ? JSON.parse(this.agence) : null;
    this.passwordForm = this.fb.group({
      currentPassword: ['',[Validators.required]],
      newPassword: ['',[Validators.required]],
      confirmPassword: ['',[Validators.required]]
    });
    this.passwordForm.get('confirmPassword').valueChanges.subscribe((result: any) => {
      if(this.passwordForm.get('newPassword').value != result){
        this.toastrService.error('Les  mot de passe ne corresponde pas', 'Mot de passe', {
          timeOut: 5000, progressBar: true, positionClass: 'toast-bottom-right', enableHtml: true
        });
        this.validform = false;
      }else{
        this.validform = true;
      }
    });
    this.passwordForm.get('currentPassword').valueChanges.subscribe((data: any) =>{
      this.userservice.checkpassword(this.userinfo.account.accountid, this.passwordForm.get('currentPassword').value).subscribe((response: any)=>{
      });
    });
    this.loadProfileImage();
  }

  loadProfileImage(): void {
    this.imageCacheService
      .getImage('../../../../assets/images/profile.jpg')
      .subscribe({
        next: (base64: string) => {
          this.profileImageBase64 = base64;
        },
        error: (error: any) => {
          console.error('Error loading profile image:', error);
          // Fallback to direct path will be used via template binding
        }
      });
  }

  updatepassword(): any{
    if (this.passwordForm.get('newPassword').value != this.passwordForm.get('confirmPassword').value){
      this.toastrService.error('Les  mot de passe ne corresponde pas', 'Mot de passe', {
        timeOut: 5000, progressBar: true, positionClass: 'toast-bottom-right', enableHtml: true
      });
      return;
    }
    this.userservice.updatepassword(this.userinfo.account.accountid, this.passwordForm.get('newPassword').value).subscribe((response: any) => {
      this.toastrService.success('Mot de passe modifier avec success', 'Mot de passe', {
        timeOut: 5000, progressBar: true, positionClass: 'toast-bottom-right', enableHtml: true
      });
      this.close();
    });
  }

  clearSignature(pad?: any) {
    const sig = pad || this.signaturePad;
    if (sig) {
      sig.clear();
    }
  }

  saveSignature(pad?: any) {
    const sig = pad || this.signaturePad;
    if (sig && sig.isEmpty()) {
      this.toastrService.error('Veuillez dessiner votre signature');
      return;
    }
    const signatureBase64 = sig.toDataURL('image/jpeg', 0.5);
    this.submitSignature(signatureBase64);
  }

  submitSignature(signatureBase64: string) {
    this.loadingSignature = true;
    this.userservice.updateSignature(this.userinfo.idpersonnel, signatureBase64).subscribe({
      next: (res: any) => {
        this.loadingSignature = false;
        this.showSignaturePad = false;
        this.signatureStatus = false;
        this.userinfo.signature = signatureBase64;
        
        // Update localStorage
        let storedUserInfo = JSON.parse(localStorage.getItem('userinfo') || '[]');
        if (storedUserInfo && storedUserInfo.length > 0) {
          storedUserInfo[0].signature = signatureBase64;
          localStorage.setItem('userinfo', JSON.stringify(storedUserInfo));
        }
        
        this.toastrService.success('Signature enregistrée avec succès');
      },
      error: (err: any) => {
        this.loadingSignature = false;
        this.toastrService.error('Erreur lors de l\'enregistrement de la signature');
      }
    });
  }

  sign(): any {
    this.signatureStatus = true;
    this.cdr.detectChanges(); // Force DOM update so ngIf evaluates synchronously
    
    setTimeout(() => {
      const canvasEl = this.liveSignatureCanvas?.nativeElement;
      
      if (!this.penPowerSdk) {
        this.penPowerSdk = new PenPowerSignSDK();
      }

      this.penPowerSdk.canvas = canvasEl;
      this.penPowerSdk.onConfirm = async (lastBase64Image: string | null) => {
         this.confirmSignatureManual();
      };
      this.penPowerSdk.onCancel = () => {
         this.cancelSignatureManual();
      };
      this.penPowerSdk.onError = (error: Error) => {
         this.signatureStatus = false;
         this.isDeviceConnected = false;
         console.error('PenPower Error:', error);
         Swal.fire({
            icon: 'error',
            title: 'Erreur de connexion',
            text: 'SVP connectez la tablette PenPower ou démarrez le service!',
            footer: error.message
          });
      };

      this.penPowerSdk.connect().then(() => {
        this.isDeviceConnected = true;
        this.toastrService.info('Veuillez signer sur la tablette', 'Prêt');
        // Start 1-minute countdown
        this.signatureTimeLeft = 60;
        if (this.signatureTimerInterval) clearInterval(this.signatureTimerInterval);
        this.signatureTimerInterval = setInterval(() => {
          this.signatureTimeLeft--;
          if (this.signatureTimeLeft <= 0) {
            clearInterval(this.signatureTimerInterval);
            if (this.signatureStatus) {
              this.toastrService.warning('Session de signature expirée après 1 minute.');
              this.cancelSignatureManual();
            }
          }
        }, 1000);
      }).catch(err => {
        this.signatureStatus = false;
        this.isDeviceConnected = false;
        Swal.fire({
            icon: 'error',
            title: 'Appareil Non Trouvé',
            text: 'Impossible de se connecter à la tablette. Vérifiez le branchement USB.',
            footer: err ? err.toString() : ''
        });
      });

      if (canvasEl) {
         const ctx = canvasEl.getContext('2d');
         if (ctx) ctx.clearRect(0,0, canvasEl.width, canvasEl.height);
      }
    }, 50);
  }

  clearLiveCanvas() {
    if (this.penPowerSdk && this.isDeviceConnected) {
      this.penPowerSdk.clear();
    }
  }

  cancelSignatureManual() {
    if (this.signatureTimerInterval) clearInterval(this.signatureTimerInterval);
    this.signatureStatus = false;
    if (this.penPowerSdk && this.isDeviceConnected) {
      this.penPowerSdk.disconnect().catch((e: any) => console.error(e));
      this.isDeviceConnected = false;
    }
    const canvas = document.getElementById('live-signature-canvas') as HTMLCanvasElement;
    if (canvas) {
       const ctx = canvas.getContext('2d');
       if (ctx) ctx.clearRect(0,0, canvas.width, canvas.height);
    }
  }

  confirmSignatureManual() {
    if (this.signatureTimerInterval) clearInterval(this.signatureTimerInterval);
    if (this.penPowerSdk && this.isDeviceConnected) {
      this.penPowerSdk.export({ format: 'png', trim: true, transparent: true }).then((finalBase64: any) => {
        if (!finalBase64 || finalBase64 === 'data:,') {
          this.toastrService.warning('Aucune signature détectée');
          return;
        }
        this.submitSignature(finalBase64);
        
        this.penPowerSdk?.disconnect().catch((e: any) => console.error(e));
        this.isDeviceConnected = false;
        this.signatureStatus = false;
      }).catch((err: any) => {
         this.toastrService.error('Erreur lors de la récupération de la signature');
      });
    }
  }

  ngAfterViewInit(): any {
    }

  ngOnDestroy() {
    if (this.signatureTimerInterval) {
      clearInterval(this.signatureTimerInterval);
    }
  }
}
